module.exports = __webpack_public_path__ + "img/lanterns.89140a8b.webp";